import transformSchedule from './transformSchedule';
import formatSchedule from './formatSchedule';
export default function fetchSchedule () {
  return window.HackerAPI.Event.ScheduleItem
    .fetchAll({ slug: 'hackthenorth2018' })
    .then(transformSchedule)
    .then(formatSchedule)
};


// WEBPACK FOOTER //
// ./src/components/Schedule/ScheduleComponent/helpers/fetchSchedule/index.js